var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ff564e","d":"M2,2V19H19V2H2M0,0H21V21H0Z","key":0}),React.createElement("g",{"transform":"translate(5.6 6.5)","key":1},[React.createElement("path",{"fill":"#016060","d":"M.673,8.74-.673,7.26l8.8-8L9.473.74Z","transform":"translate(0 0)","key":0}),React.createElement("path",{"fill":"#016060","d":"M8.812,7.1h-2V1H0V-1H8.812Z","transform":"translate(0.988)","key":1})])]);
}

ExternalLink.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
